import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoError} from "@/components/shared";
import {routePlanService} from "@/service/routePlan.service";
import {useEffect, useState} from "react";

type DeleteInfowindowProps = {
  variantId: number;
  sourceRoute: RouteDetails_RP;
  bpData: UserBoarding_RP;
  variantRoute: any;
  currentVariant: any;
  setCurrentVariant: any;
  closePopup: any;
  refreshSingleRoute: any;
};
interface FormValues {
  bpId: number;
  name: string;
  latitude: string;
  longitude: string;
  routeId: number | null;
}
export const DeletetBpwindow = function ({
  variantId,
  sourceRoute,
  bpData,
  variantRoute,
  currentVariant,
  setCurrentVariant,
  closePopup,
  refreshSingleRoute
}: DeleteInfowindowProps) {
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [request, setRequest] = useState<any | {}>({});
  const [processingPopupmodal, setProcessingPopupmodal] = useState(false);
  const [oldCurrentVariantId, setOldCurrentVariantId] = useState<number | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState<any>(null);

  useEffect(() => {
    const request = {
      bpId: bpData.id,
      name: bpData.name,
      latitude: bpData.latitude.toString(),
      longitude: bpData.longitude.toString(),
      sRoute: sourceRoute.id,
      dRoute: sourceRoute.id,
      operation: 3, //delete operation
      rType: 0, //default 0 for delete
      reRoute: 1,
      routePlanVariantId: variantId
    };
    onSubmit(request);
  }, []);
  useEffect(() => {
    if (oldCurrentVariantId && oldCurrentVariantId !== 0) {
      handlePopupModal();
    }
  }, [oldCurrentVariantId]);
  const handlePopupModal = () => {
    setProcessingPopupmodal(true);
  };

  const onSubmit = (data: any) => {
    setRequest(data);
    setConfirmPopup(true);
  };
  const deleteBp = async (optionType: string) => {
    setConfirmPopup(false);
    //option1 -> Add Boarding Point Only,option2 -> Add Boarding Point and Replan Route
    const req = {
      ...request,
      rType: 1,
      reRoute: optionType === "option1" ? 0 : optionType === "option2" ? 2 : 0
    };
    await routePlanService
      .bpOperations(req)
      .then(async (response: any) => {
        // console.log("Response", response);
        if (response?.status === "success") {
          setOldCurrentVariantId(currentVariant);
          setConfirmPopup(false);
          setCurrentVariant(0); //to trigger the useEffect in variant map and fetch new current variant
        } else {
          setErrorMessage("Insufficient credit points.");
        }
      })
      .catch(err => {
        if (err?.errors?.length > 0) {
          err?.errors?.forEach(
            ({field, message}: {field: any; message: string}) => {
              //setError(field, {type: "server", message: message});
            }
          );
        }
      })
      .finally(() => {
        //setLoading(false);
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };
  const changeVariant = () => {
    if (sourceRoute.id) {
      refreshSingleRoute(sourceRoute.id);
    }
    closePopup();
    setCurrentVariant(oldCurrentVariantId);
    setOldCurrentVariantId(0);
  };
  return (
    <>
      {errorMessage ? <NeoError message={errorMessage}></NeoError> : null}
      <NeoModal
        actionType={"boardingConformation"}
        onOpen={confirmPopup}
        onClose={() => {
          setConfirmPopup(false);
          closePopup();
        }}
        hasActions={false}
        data={{
          message: {
            title: "Delete Boarding Point or Replan Route",
            options: {
              option1: {
                subTitle: "Delete Boarding Point Only",
                content:
                  "Delete this Boarding Point from the route. The current route will remain unchanged."
              },
              option2: {
                subTitle: "Delete Boarding Point And Replan Route",
                content:
                  "Delete this Boarding Point and re-optimize the route to exclude this stop, improving the route for the remaining boarding points."
              }
            }
          },
          onConfirm: deleteBp,
          reqData: {routeId: sourceRoute.id}
        }}
      ></NeoModal>
      <NeoModal
        actionType={"routePlanProcessingPopup"}
        onOpen={processingPopupmodal}
        onClose={() => setProcessingPopupmodal(false)}
        hasActions={false}
        data={{
          changeVariant,
          newAddedVariantId: oldCurrentVariantId,
          type: "addBP"
        }}
      ></NeoModal>
    </>
  );
};
